var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x35_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#fafafa",
    strokeWidth: 24.576
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6E96F"
    },
    d: "M453.481,402.747c-28.353-17.478-41.329-72.613-41.329-90.987v-77.245 c0-84.141-60.354-154.138-140.122-169.171c2.114-2.739,3.914-5.743,5.283-8.997c2.064-4.853,3.197-10.223,3.197-15.786 c0.007-8.359-2.559-16.23-6.932-22.682c-4.373-6.474-10.539-11.592-17.829-14.682C250.89,1.133,245.52,0,239.957,0 c-8.352,0-16.223,2.566-22.682,6.939c-6.467,4.366-11.592,10.539-14.682,17.829c-2.058,4.861-3.19,10.223-3.19,15.793 c-0.007,8.344,2.566,16.223,6.932,22.682c0.487,0.717,1.004,1.42,1.542,2.101c-79.76,15.04-140.115,85.037-140.115,169.171v77.245 c0,18.374-12.976,73.509-41.332,90.987C-62.877,457.789,90.723,512,239.957,512S542.791,457.789,453.481,402.747z M227.34,32.067 c1.649-2.438,3.986-4.38,6.703-5.52c1.813-0.767,3.785-1.197,5.914-1.197c3.19,0.007,6.058,0.954,8.495,2.595 c2.438,1.642,4.38,3.986,5.528,6.703c0.76,1.807,1.183,3.778,1.183,5.915c-0.007,3.19-0.946,6.05-2.588,8.487 c-1.642,2.438-3.986,4.38-6.696,5.528c-1.814,0.76-3.786,1.19-5.922,1.19c-3.19-0.007-6.05-0.946-8.495-2.588 c-2.43-1.649-4.373-3.993-5.52-6.71c-0.76-1.807-1.19-3.771-1.19-5.907C224.759,37.364,225.698,34.504,227.34,32.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBD75C"
    },
    d: "M476.393,444.247c0,37.414-106.55,67.753-237.999,67.753c-131.44,0-237.988-30.339-237.988-67.753 c0-37.414,106.548-67.753,237.988-67.753C369.843,376.494,476.393,406.833,476.393,444.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D85D"
    },
    d: "M254.166,35.084c4.373,11.19-4.854,19.858-14.209,20.367V512c24.016,0,48.046-1.362,71.904-4.043 c26.159-2.939,52.211-7.406,77.696-14.073c20.267-5.327,40.59-11.914,59.043-21.972c11.47-6.237,24.754-14.782,29.708-27.543 c4.559-11.75-1.771-22.832-10.309-30.812c-6.933-6.481-15.65-10.523-22.475-17.047c-8.129-7.778-14.043-17.693-18.718-27.829 c-8.115-17.542-14.66-38.168-14.66-57.645v-72.95c0-38.26-10.882-75.194-33.83-106.092 c-25.629-34.532-63.975-58.713-106.264-66.671C292.24,39.156,272.977-0.014,239.957,0v25.665 c5.456-0.294,10.969,2.193,13.836,8.559l0.086,0.201c0.036,0.071,0.072,0.143,0.101,0.229c0.036,0.101,0.093,0.186,0.122,0.287 C254.144,35.035,254.166,35.084,254.166,35.084z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD8A43"
    },
    d: "M195.396,397.599c-99.816,4.667-174.91,24.905-174.91,49.193 c0,27.658,97.472,50.082,217.908,50.204V396.588C223.684,396.603,209.296,396.94,195.396,397.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D7A3B"
    },
    d: "M288.031,397.829c-15.657-0.824-31.915-1.248-48.633-1.248c-0.33,0-0.667,0.007-1.004,0.007 v100.408c0.337,0,0.674,0.007,1.004,0.007c120.91,0,218.923-22.474,218.923-50.21C458.321,422.891,385.535,402.89,288.031,397.829 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDC953"
    },
    d: "M295.337,424.841c0,29.657-24.044,53.702-53.688,53.702c-29.643,0-53.68-24.044-53.68-53.702 c0-9.943,2.71-19.263,7.427-27.242c14.223-0.674,28.941-1.018,44.002-1.018c16.718,0,32.977,0.424,48.633,1.248 C292.684,405.757,295.337,414.998,295.337,424.841z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 222.329,
    cy: 448.799,
    r: 11.047
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M114.499,218.615c0.007-25.005,7.947-48.11,21.474-67.058 c13.52-18.933,32.625-33.657,54.834-41.715c5.262-1.914,7.979-7.721,6.072-12.99c-1.915-5.262-7.729-7.972-12.99-6.058 c-26.145,9.484-48.54,26.747-64.423,48.984c-15.882,22.224-25.256,49.494-25.248,78.836c0,5.592,4.541,10.13,10.136,10.13 C109.957,228.744,114.499,224.206,114.499,218.615L114.499,218.615z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6E96F"
    },
    d: "M453.481,402.747c-28.353-17.478-41.329-72.613-41.329-90.987v-77.245 c0-84.141-60.354-154.138-140.122-169.171c2.114-2.739,3.914-5.743,5.283-8.997c2.064-4.853,3.197-10.223,3.197-15.786 c0.007-8.359-2.559-16.23-6.932-22.682c-4.373-6.474-10.539-11.592-17.829-14.682C250.89,1.133,245.52,0,239.957,0 c-8.352,0-16.223,2.566-22.682,6.939c-6.467,4.366-11.592,10.539-14.682,17.829c-2.058,4.861-3.19,10.223-3.19,15.793 c-0.007,8.344,2.566,16.223,6.932,22.682c0.487,0.717,1.004,1.42,1.542,2.101c-79.76,15.04-140.115,85.037-140.115,169.171v77.245 c0,18.374-12.976,73.509-41.332,90.987C-62.877,457.789,90.723,512,239.957,512S542.791,457.789,453.481,402.747z M227.34,32.067 c1.649-2.438,3.986-4.38,6.703-5.52c1.813-0.767,3.785-1.197,5.914-1.197c3.19,0.007,6.058,0.954,8.495,2.595 c2.438,1.642,4.38,3.986,5.528,6.703c0.76,1.807,1.183,3.778,1.183,5.915c-0.007,3.19-0.946,6.05-2.588,8.487 c-1.642,2.438-3.986,4.38-6.696,5.528c-1.814,0.76-3.786,1.19-5.922,1.19c-3.19-0.007-6.05-0.946-8.495-2.588 c-2.43-1.649-4.373-3.993-5.52-6.71c-0.76-1.807-1.19-3.771-1.19-5.907C224.759,37.364,225.698,34.504,227.34,32.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBD75C"
    },
    d: "M476.393,444.247c0,37.414-106.55,67.753-237.999,67.753c-131.44,0-237.988-30.339-237.988-67.753 c0-37.414,106.548-67.753,237.988-67.753C369.843,376.494,476.393,406.833,476.393,444.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D85D"
    },
    d: "M254.166,35.084c4.373,11.19-4.854,19.858-14.209,20.367V512c24.016,0,48.046-1.362,71.904-4.043 c26.159-2.939,52.211-7.406,77.696-14.073c20.267-5.327,40.59-11.914,59.043-21.972c11.47-6.237,24.754-14.782,29.708-27.543 c4.559-11.75-1.771-22.832-10.309-30.812c-6.933-6.481-15.65-10.523-22.475-17.047c-8.129-7.778-14.043-17.693-18.718-27.829 c-8.115-17.542-14.66-38.168-14.66-57.645v-72.95c0-38.26-10.882-75.194-33.83-106.092 c-25.629-34.532-63.975-58.713-106.264-66.671C292.24,39.156,272.977-0.014,239.957,0v25.665 c5.456-0.294,10.969,2.193,13.836,8.559l0.086,0.201c0.036,0.071,0.072,0.143,0.101,0.229c0.036,0.101,0.093,0.186,0.122,0.287 C254.144,35.035,254.166,35.084,254.166,35.084z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD8A43"
    },
    d: "M195.396,397.599c-99.816,4.667-174.91,24.905-174.91,49.193 c0,27.658,97.472,50.082,217.908,50.204V396.588C223.684,396.603,209.296,396.94,195.396,397.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D7A3B"
    },
    d: "M288.031,397.829c-15.657-0.824-31.915-1.248-48.633-1.248c-0.33,0-0.667,0.007-1.004,0.007 v100.408c0.337,0,0.674,0.007,1.004,0.007c120.91,0,218.923-22.474,218.923-50.21C458.321,422.891,385.535,402.89,288.031,397.829 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDC953"
    },
    d: "M295.337,424.841c0,29.657-24.044,53.702-53.688,53.702c-29.643,0-53.68-24.044-53.68-53.702 c0-9.943,2.71-19.263,7.427-27.242c14.223-0.674,28.941-1.018,44.002-1.018c16.718,0,32.977,0.424,48.633,1.248 C292.684,405.757,295.337,414.998,295.337,424.841z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 222.329,
    cy: 448.799,
    r: 11.047
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M114.499,218.615c0.007-25.005,7.947-48.11,21.474-67.058 c13.52-18.933,32.625-33.657,54.834-41.715c5.262-1.914,7.979-7.721,6.072-12.99c-1.915-5.262-7.729-7.972-12.99-6.058 c-26.145,9.484-48.54,26.747-64.423,48.984c-15.882,22.224-25.256,49.494-25.248,78.836c0,5.592,4.541,10.13,10.136,10.13 C109.957,228.744,114.499,224.206,114.499,218.615L114.499,218.615z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.71ab74eaf0449a25ec5e1ae7f8360a6a.svg";
export { ForwardRef as ReactComponent };